import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { OrderDispatchPage } from '#/pages/orders'
import { useEscapeClose } from '#/shared/lib/hooks'

export const Route = createFileRoute('/_shell/orders/$orderId/dispatch')({
  component: SubRoute,
})

function SubRoute() {
  const { orderId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/orders/$orderId', params: { orderId }, search: listSearch as never })
  }, [navigate, listSearch, orderId])
  useEscapeClose(handleClose)
  return <OrderDispatchPage shipmentId={orderId} onClose={handleClose} />
}
